"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byDateDesc = exports.byDate = exports.byAlphabetically = exports.byOrder = void 0;
function byOrder(a, b, isDesc) {
    if (isDesc === void 0) { isDesc = false; }
    return (a.order - b.order) * (isDesc ? -1 : 1);
}
exports.byOrder = byOrder;
function byAlphabetically(a, b) {
    if (a < b) {
        return -1;
    }
    else if (a > b) {
        return 1;
    }
    else {
        return 0;
    }
}
exports.byAlphabetically = byAlphabetically;
function toTime(t) {
    return (typeof t === "string" ? new Date(t) : t).getTime();
}
function byDate(a, b) {
    return toTime(a.date) - toTime(b.date);
}
exports.byDate = byDate;
function byDateDesc(a, b) {
    return -byDate(a, b);
}
exports.byDateDesc = byDateDesc;
